<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="myIntegral subpage" ref="myIntegralRef">
    <Header
      v-if="$route.query.platform !== 'mini'"
      :is-sub-page="true"
      backgroundColor="#874DD5"
      titleColor="#FFFFFF"
      ref="navBarRef"
      title="我的积分"
      :is-black-icon="false"
    >
      <!--:backImg="'~@/assets/images/icons/icon-back.png'"-->
      <template v-slot:rightBtn>
        <span class="integralRule" @click='skipToRule'>积分规则</span>
      </template>
    </Header>
    <div ref='contentRef' style="margin-top: -1px">
      <div class="integral-recharge">
        <div class="recharge-block">
          <div class="balance-font">
            <span class="integral-balance">{{this.scoreTotal}}</span>
            <span class="integral-font">积分</span>
            <span v-if="$route.query.platform === 'mini'" @click='skipToRule' style="color: #fff; margin-left: 10px;">积分规则</span>
          </div>
          <div @click="gotoPay('/user/myIntegral/rechargePayTop')" class="recharge-btn">充值</div>
        </div>
      </div>
      <cube-tab-bar class="tab" v-model="selectedLabel" show-slider>
        <cube-tab v-for="(item,index) in tabs" :label="item" :key="index"></cube-tab>
      </cube-tab-bar>
      <cube-tab-panels v-model="selectedLabel">
        <cube-tab-panel class="panel" v-for="(item,index) in tabs" :label="item" :key="index">

          <template v-for="(item,idx) in scoreList[index].event">
            <div class="bar" :key="item+'_'+idx">
              <div class="bar-left">
                <div class="info">{{item.title}}</div>
                <div class="time">{{item.time}}</div>
              </div>
              <div class="add-change">{{item.value}}</div>
            </div>
            <div class="line-center" :key="idx">
              <span class="line"></span>
            </div>
          </template>

        </cube-tab-panel>
      </cube-tab-panels>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryUserScore } from '@/api/shop'
import { queryUserDetail } from '@/api/user'

export default {
  name: '',
  data () {
    return {
      selectedLabel: '全部',
      tabs: ['全部', '收入', '支出'],
      consumeRecord: 5,
      scoreTotal: 0,
      scoreList: [{
        // all
        event: [
          {
            title: '',
            time: '',
            value: ''
          }
        ]
      }, {
        // in
        event: [{
          title: '',
          time: '',
          value: ''
        }]
      }, {
        // out
        event: [{
          title: '',
          time: '',
          value: ''
        }]
      }
      ]
    }
  },
  mounted () {
    document.title = '我的积分'

    try {
      this.getData()
    } catch (e) {
      console.log(e.message)
    }
  },
  components: {
    Header
  },
  watch: {
    '$route' (to, from) {
      // console.log('to:'+to)
      console.log('from:' + from.name)
      if (from.name === 'rechargePayTop') {
        this.getData()
      }
    }
  },
  methods: {
    skipToRule () {
      this.$router.push('/user/myIntegral/integralRule?platform=' + this.$route.query.platform)
    },
    getData () {
      queryUserScore({
        page: 1,
        size: 100
      }).then((res) => {
        console.log('111111111')
        this.scoreList[0].event.splice(0)
        this.scoreList[1].event.splice(0)
        this.scoreList[2].event.splice(0)
        console.log('222222222222')
        res.data.records.forEach((item, idx) => {
          var score = {
            title: item.eventName,
            time: item.createTime,
            value: item.value
          }

          this.scoreList[0].event.push(score)
          console.log('push  all  score=' + score.title + '  ' + score.time + '  ' + score.value)
          if (item.scoreTypeCode === 1) {
            this.scoreList[1].event.push(score)
          } else if (item.scoreTypeCode === 0) {
            this.scoreList[2].event.push(score)
          }
        })
      })

      queryUserDetail({}).then((res) => {
        this.scoreTotal = res.data.scoreValue
      })
    },

    gotoPay (url) {
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.redirectTo({ url: '/pages/recharge/recharge' })
      } else {
        this.$router.push({ path: url })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.myIntegral
  .integral-recharge
    height 94px
    padding 15px
    background-color #874DD5;
    display flex
    align-items center
    flex-wrap wrap
    .recharge-block
      padding 0 20px
      background-color #935FD9
      width 345px
      height 64px
      display flex
      justify-content space-between
      align-items center
      border-radius 5px
      .balance-font
        display flex
        align-items center
        .integral-balance
          font-size 25px
          color #fff
        .integral-font
          font-size 15px
          color #fff
          margin-left 5px
      .recharge-btn
        display flex
        justify-content center
        align-items center
        color #fff
        border 1px solid #fff
        height 24px
        width 105px
        border-radius 5px
  .tab
    height 41px
    font-size 15px
    margin-bottom 10px
    background-color #fff
  .panel
    .bar
      background-color #fff
      height 60px
      display flex
      justify-content space-between
      align-items center
      padding 0 15px
      .bar-left
        height 60px
        display inline-block
        align-items left
        .info
          margin-top 13px
          font-size 15px
          color #545454
          font-weight 400
          text-align left
        .time
          font-size 13px
          text-align left
          margin-top 5px
      .add-change
        font-size 15px
        color #662C85
      .reduce-change
        font-size 15px
        color #9C9C9C
    .line-center
      display flex
      justify-content center;
      background-color #fff
      width 100%
      .line
        width 345px
        background-color #DDDDDD
        height 1px
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
